// Recovered compiled webpack factory 47362. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e, t) {
    var r = e.length;
    for (e.push(t); 0 < r; ) {
      var n = (r - 1) >>> 1,
        a = e[n];
      if (0 < o(a, t)) ((e[n] = t), (e[r] = a), (r = n));
      else break;
    }
  }
  function n(e) {
    return 0 === e.length ? null : e[0];
  }
  function a(e) {
    if (0 === e.length) return null;
    var t = e[0],
      r = e.pop();
    if (r !== t) {
      e[0] = r;
      for (var n = 0, a = e.length, i = a >>> 1; n < i; ) {
        var s = 2 * (n + 1) - 1,
          l = e[s],
          u = s + 1,
          c = e[u];
        if (0 > o(l, r))
          u < a && 0 > o(c, l)
            ? ((e[n] = c), (e[u] = r), (n = u))
            : ((e[n] = l), (e[s] = r), (n = s));
        else if (u < a && 0 > o(c, r)) ((e[n] = c), (e[u] = r), (n = u));
        else break;
      }
    }
    return t;
  }
  function o(e, t) {
    var r = e.sortIndex - t.sortIndex;
    return 0 !== r ? r : e.id - t.id;
  }
  if (
    ((t.unstable_now = void 0),
    "object" == typeof performance && "function" == typeof performance.now)
  ) {
    var i,
      s = performance;
    t.unstable_now = function () {
      return s.now();
    };
  } else {
    var l = Date,
      u = l.now();
    t.unstable_now = function () {
      return l.now() - u;
    };
  }
  var c = [],
    f = [],
    d = 1,
    p = null,
    h = 3,
    _ = !1,
    m = !1,
    g = !1,
    y = !1,
    v = "function" == typeof setTimeout ? setTimeout : null,
    b = "function" == typeof clearTimeout ? clearTimeout : null,
    E = "undefined" != typeof setImmediate ? setImmediate : null;
  function R(e) {
    for (var t = n(f); null !== t; ) {
      if (null === t.callback) a(f);
      else if (t.startTime <= e) (a(f), (t.sortIndex = t.expirationTime), r(c, t));
      else break;
      t = n(f);
    }
  }
  function P(e) {
    if (((g = !1), R(e), !m))
      if (null !== n(c)) ((m = !0), S || ((S = !0), i()));
      else {
        var t = n(f);
        null !== t && M(P, t.startTime - e);
      }
  }
  var S = !1,
    O = -1,
    T = 5,
    w = -1;
  function j() {
    return !!y || !(t.unstable_now() - w < T);
  }
  function x() {
    if (((y = !1), S)) {
      var e = t.unstable_now();
      w = e;
      var r = !0;
      try {
        e: {
          ((m = !1), g && ((g = !1), b(O), (O = -1)), (_ = !0));
          var o = h;
          try {
            t: {
              for (R(e), p = n(c); null !== p && !(p.expirationTime > e && j()); ) {
                var s = p.callback;
                if ("function" == typeof s) {
                  ((p.callback = null), (h = p.priorityLevel));
                  var l = s(p.expirationTime <= e);
                  if (((e = t.unstable_now()), "function" == typeof l)) {
                    ((p.callback = l), R(e), (r = !0));
                    break t;
                  }
                  (p === n(c) && a(c), R(e));
                } else a(c);
                p = n(c);
              }
              if (null !== p) r = !0;
              else {
                var u = n(f);
                (null !== u && M(P, u.startTime - e), (r = !1));
              }
            }
            break e;
          } finally {
            ((p = null), (h = o), (_ = !1));
          }
        }
      } finally {
        r ? i() : (S = !1);
      }
    }
  }
  if ("function" == typeof E)
    i = function () {
      E(x);
    };
  else if ("undefined" != typeof MessageChannel) {
    var A = new MessageChannel(),
      C = A.port2;
    ((A.port1.onmessage = x),
      (i = function () {
        C.postMessage(null);
      }));
  } else
    i = function () {
      v(x, 0);
    };
  function M(e, r) {
    O = v(function () {
      e(t.unstable_now());
    }, r);
  }
  ((t.unstable_IdlePriority = 5),
    (t.unstable_ImmediatePriority = 1),
    (t.unstable_LowPriority = 4),
    (t.unstable_NormalPriority = 3),
    (t.unstable_Profiling = null),
    (t.unstable_UserBlockingPriority = 2),
    (t.unstable_cancelCallback = function (e) {
      e.callback = null;
    }),
    (t.unstable_forceFrameRate = function (e) {
      0 > e || 125 < e
        ? console.error(
            "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
          )
        : (T = 0 < e ? Math.floor(1e3 / e) : 5);
    }),
    (t.unstable_getCurrentPriorityLevel = function () {
      return h;
    }),
    (t.unstable_next = function (e) {
      switch (h) {
        case 1:
        case 2:
        case 3:
          var t = 3;
          break;
        default:
          t = h;
      }
      var r = h;
      h = t;
      try {
        return e();
      } finally {
        h = r;
      }
    }),
    (t.unstable_requestPaint = function () {
      y = !0;
    }),
    (t.unstable_runWithPriority = function (e, t) {
      switch (e) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          e = 3;
      }
      var r = h;
      h = e;
      try {
        return t();
      } finally {
        h = r;
      }
    }),
    (t.unstable_scheduleCallback = function (e, a, o) {
      var s = t.unstable_now();
      switch (
        ((o =
          "object" == typeof o && null !== o && "number" == typeof (o = o.delay) && 0 < o
            ? s + o
            : s),
        e)
      ) {
        case 1:
          var l = -1;
          break;
        case 2:
          l = 250;
          break;
        case 5:
          l = 0x3fffffff;
          break;
        case 4:
          l = 1e4;
          break;
        default:
          l = 5e3;
      }
      return (
        (l = o + l),
        (e = {
          id: d++,
          callback: a,
          priorityLevel: e,
          startTime: o,
          expirationTime: l,
          sortIndex: -1,
        }),
        o > s
          ? ((e.sortIndex = o),
            r(f, e),
            null === n(c) && e === n(f) && (g ? (b(O), (O = -1)) : (g = !0), M(P, o - s)))
          : ((e.sortIndex = l), r(c, e), m || _ || ((m = !0), S || ((S = !0), i()))),
        e
      );
    }),
    (t.unstable_shouldYield = j),
    (t.unstable_wrapCallback = function (e) {
      var t = h;
      return function () {
        var r = h;
        h = t;
        try {
          return e.apply(this, arguments);
        } finally {
          h = r;
        }
      };
    }));
}
